import { Bath, BedSingle, CarFront, Diamond } from "lucide-react";

export const PropertyInstruction = ({ PropertyData }) => {
  return (
    <>
      <div className="bg-white rounded-2xl border font-medium text-lg text-gray-500 border-gray-200 p-5 md:p-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
          <div className="flex flex-col items-center gap-2">
            <div>Bedrooms</div>
            <div className="flex items-center gap-3">
              <BedSingle size={22} />
              <div className="text-2xl text-black">
                {PropertyData?.Bedrooms || 0}
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center gap-2">
            <div>Bathrooms</div>
            <div className="flex items-center gap-3">
              <Bath size={22} />
              <div className="text-2xl text-black">
                {PropertyData?.Bathrooms || 0}
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center gap-2">
            <div>Square Area</div>
            <div className="flex items-center gap-3">
              <Diamond size={22} />
              <div className="text-2xl text-black">
                {
                  PropertyData?.house_size == "" ? "-" :
                    <p>
                      {PropertyData?.house_size} × {PropertyData?.land_size} m<sup>2</sup>
                    </p>
                }

              </div>
            </div>
          </div>

          <div className="flex flex-col items-center gap-2">
            <div>Garrage</div>
            <div className="flex items-center gap-3">
              <CarFront size={22} />
              <div className="text-2xl text-black">
                {PropertyData?.garage_spaces?.toUpperCase() || "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
